import { Observable, Subscription } from 'rxjs';
import { LookupDialogService } from './lookup-dialog.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { CompleterItem } from '../ngx-completer/model/completer-item';
import { DataService } from '../ngx-completer/services/data.service';

export class LookupAutocompleteData extends DataService {
  private remoteSearch: Subscription;
  private _dataField: string | null = null;

  constructor(private lookupDialogService: LookupDialogService) {
    super();
  }

  public dataField(dataField: string) {
    this._dataField = dataField;
  }

  public search(term: string): Observable<CompleterItem[]> {
    this.cancel();
    
    return this.lookupDialogService.getAutocompleteOptions(term)
      .pipe(map(data => this.extractValue(data.Items || [], this._dataField)))
      .pipe(map(values => this.extractMatches(values, term)))
      .pipe(map(matches => this.processResults(matches)));
  }

  public cancel() {
    if (this.remoteSearch) {
      this.remoteSearch.unsubscribe();
    }
  }

  public convertToItem(data: any): CompleterItem | null {
    return super.convertToItem(data);
  }
}


export function autocompleteDataFactory (lookupDialogService: LookupDialogService, httpClient: HttpClient) {
  return () => {
    return new LookupAutocompleteData(lookupDialogService);
  };
}

export let AutocompleteDataFactoryProvider = {
  provide: LookupAutocompleteData,
  useFactory: autocompleteDataFactory,
  deps: [LookupDialogService]
};
